<template>
  <div class="userdetail-wrap">
    <div class="title">用户信息</div>
    <div class="item-wrap">
	    <div class="item">
	    	<span class="item-title">头像:</span>
	    	<img :src="imgDomain + userInfo.user_icon" v-if="userInfo.user_icon" class="user-icon">
        <img :src="imgDomain + 'FqqL2MeSJIgNiuaYF_cLHT2YUOGa'" class="user-icon" v-else>
	    </div>
	    <div class="item">
	    	<span class="item-title">手机号:</span>
	    	<span>{{userInfo.account}}</span>
	    </div>
      <div class="item">
	    	<span class="item-title">会员等级:</span>
	    	<span v-if="userInfo.member_card_name">{{userInfo.member_card_name}}</span>
        <span v-else>无</span>
	    </div>
    </div>
    <div class="item-wrap">
	    <div class="item">
	    	<span class="item-title">用户昵称:</span>
	    	<span>{{userInfo.user_name}}</span>
	    </div>
	    <div class="item">
	    	<span class="item-title">QQ:</span>
	    	<span>{{userInfo.qq}}</span>
	    </div>
    </div>
    <div class="title">店铺信息</div>
    <div class="item-wrap">
	    <div class="item">
	    	<span class="item-title">店铺旺旺:</span>
	    	<span>{{userInfo.wangwang}}</span>
	    </div>
    </div>
    <div class="title">余额明细</div>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		     <el-table-column
		      prop="batch_serial_number"
		      label="流水号"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="describe"
		      label="备注"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="交易类型"
		      align="center"
        >
          <template slot-scope="scope">
          	 <span v-if="scope.row.type == 1">收入</span>
          	 <span v-if="scope.row.type == 2">支出</span>
          </template>
		    </el-table-column>
		    <el-table-column
		      prop="now_balance"
		      label="剩余余额"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="金额"
		      align="center"
        >
          <template slot-scope="scope">
          	 <span v-if="scope.row.type == 1">+{{scope.row.amount}}</span>
          	 <span v-if="scope.row.type == 2">-{{scope.row.amount}}</span>
          </template>
		    </el-table-column>
		    <el-table-column
		      prop="create_time"
		      label="时间"
		      align="center"
        >
		    </el-table-column>
		  </el-table>
		  <common-pagination
		  :total="total"
      :page_size="page_size"
		   @size-change="handelPagesizeChange"
		   @page-change="handlePageChange"
		  ></common-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { userDetail, userBalanceRecord } from '@/api/user';
import CommonPagination from '@/components/CommonPagination';

export default {
  name: 'userdetail',
  data() {
  	return {
      uuid: '',
      userInfo: {},
      tableData: [
        {
        	batch_serial_number: '12345678911111',
          describe: '充值',
          type: '1',
          now_balance: '200.00',
          create_time: '2019-05-27 19:21:10',
          amount: '80.00'
        }
      ],
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  	} 
  },
  computed: {
    ...mapState(['imgDomain']),
  },
  components: {
    CommonPagination,
  },
  mounted() {
  	let uuid = this.$route.query.id;
  	this.uuid = uuid;
  	this.getUserDetail(uuid);
  	this.getUserBalanceRecord();
  },
  methods: {
  	async getUserDetail(uuid) {
      const {data, status } = await userDetail(uuid);
      if (status !== 200) return
      this.userInfo = data;
      console.log(data, 'detail')
  	},
  	async getUserBalanceRecord() {
  		 let postData = {
          page_index: this.page_index,
          page_size: this.page_size
  		 }
       const { data, status } = await userBalanceRecord(this.uuid, postData);
       if (status !== 200) return
       this.tableData = data.data;
       this.total = data.total
       console.log(data, '用户余额明细')
  	},
  	handelPagesizeChange(size) {
      this.page_size = size;
      this.getUserBalanceRecord();
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this.getUserBalanceRecord();
  	}
  }
}
</script>

<style lang="less" scoped>
.userdetail-wrap {
	.title {
		margin-bottom: 30px;
		font-size: 20px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(76,76,76,1);
    line-height: 28px
	}
	.item-wrap {
		display: flex;
		.item {
			display: flex;
			align-items: center;
			width: 400px;
			margin-right: 100px;
			margin-bottom: 50px;
			.item-title {
				margin-right: 30px;
				font-size: 16px;
		    font-family: PingFangSC-Regular;
		    font-weight: 400;
		    color: rgba(153,153,153,1);
      }
      .user-icon {
        width: 100px;
        height: 100px;
      }
		}
	}
}

</style>
